import React, { useEffect, useState } from "react";
import Casino from "./../../assets/images/casino.svg";
import Exchange from "./../../assets/images/exchange.svg";
import Sportsbook from "./../../assets/images/sportsbook.svg";
import Sports from "./../../assets/images/sports.svg";
import FullSite from "./../../assets/images/full-site.svg";
import WalletSvg from "./../../assets/images/wallet.svg";
import { domain } from "../../constants/Branding";
import { getEnvVariable } from "../../constants/whitelabelEnv";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../models/RootState";
import { SiteConfig } from "../../models/SiteConfig";
import { themes } from "./MyProfile/MyProfile";
import HomeIcon from '@mui/icons-material/Home';

const WhiteLabelLogo = getEnvVariable(domain, 'logo');
const BrandName = getEnvVariable(domain, 'BRAND_NAME');
const showSites = typeof BrandName === 'string' && BrandName.toLowerCase() !== 'winfast99' && (BrandName.toLowerCase() === 'hindu777' || BrandName.toLowerCase() === 'lotus365');

type FooterItem = {
  icon: string | React.ComponentType<any>;
  label: string;
  path: string;
  /**
   * Returns true if the item should be shown (enabled)
   */
  isEnabled?: (siteConfig: SiteConfig) => boolean;
};

const Footer: React.FC = () => {
  const [activeTab, setActiveTab] = useState("Fantasy");
  const navigate = useNavigate();
  const location = useLocation();

  const siteConfig = useSelector(
    (state: RootState) => state.userDetails.siteConfig
  );



  const footerItems: FooterItem[] = [
    {
      icon: Casino,
      label: "Casino",
      path: "casino",
      isEnabled: (siteConfig) => siteConfig.isCasinoEnabled, // show if casino is enabled
    },
    {
      icon: Exchange,
      label: "Exchange",
      path: "exchange",
      isEnabled: (siteConfig) => siteConfig.isSportsEnabled, // show if exchange is enabled
    },
    {
      icon: WhiteLabelLogo,
      label: "Fantasy",
      path: "fantasy",
      isEnabled: () => true, // show if sports is enabled
    },
    {
      icon: Sportsbook,
      label: "Sportsbook",
      path: "sportsbook",
      isEnabled: (siteConfig) => siteConfig.isSportsEnabled, // show if sportsbook is enabled
    },
    {
      icon: WalletSvg,
      label: "Wallet",
      path: "wallet",
      isEnabled: () => true,
    },
  ];

  const handleItemClick = (tab: FooterItem) => {
    setActiveTab(tab.label);
    navigate("/" + tab.path);
  };

  useEffect(() => {
    const currentItem = footerItems.find((item) =>
      location.pathname.includes(item.path)
    );
    if (currentItem) {
      setActiveTab(currentItem.label);
    }
  }, [location.pathname]);

  // ✅ Filter only enabled footer items
  const enabledFooterItems = footerItems.filter((item) => {
    if (typeof item.isEnabled === "function") {
      return item.isEnabled(siteConfig);
    }
    return item.isEnabled !== false; // default true
  });

  return (
    <>
      {/* Pulse animation keyframes */}
      <style>
        {`
          @keyframes pulse-scale {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
          }
        `}
      </style>
      <footer
        // Avoid CSS transforms here: transforms create a new compositing layer and can cause
        // iframes to "win" click/paint ordering in some browsers/emulation modes.
        // Keep above iframe, but below MUI Dialog (z-index 1300)
        className={`fixed bottom-0 left-0 right-0 mx-auto w-[calc(100%-1rem)] md:w-[95%] text-sm md:max-w-[25rem] font-medium rounded-2xl border-b-0 border border-border-color text-zinc-400 flex flex-col px-5 py-2 justify-center z-[1000]`}
        style={{
          background:
            "linear-gradient(to top, rgba(5,19,20), rgba(5,19,20,0.8))",
        }}
      >
        <nav className="flex justify-between w-full">
          {enabledFooterItems.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col text-center whitespace-nowrap ${item.label === activeTab
                ? "text-border-color"
                : "text-text-color"
                }`}
              onClick={() => handleItemClick(item)}
              style={{ cursor: "pointer" }}
            >
              {typeof item.icon === 'string' ? (
                <img
                  loading="lazy"
                  src={item.icon}
                  alt={item.label}
                  className={`self-center ${item.label === "Promos"
                    ? "aspect-[1.45] w-[26px]"
                    : item.label === "Wallet"
                      ? "w-5 rounded-lg aspect-[1.11]"
                      : item.label === "Fantasy"
                        ? "w-[48px]"
                        : "aspect-square w-[18px]"
                    }`}
                  style={{
                    filter:
                      item.label === activeTab
                        ? (item.label !== "Fantasy" ? 'var(--filter-color)' : 'none')
                        : item.label !== "Fantasy"
                          ? "brightness(0) saturate(100%) invert(69%) sepia(0%) saturate(923%) hue-rotate(219deg) brightness(101%) contrast(99%)"
                          : "none",
                    height: item.label === "Fantasy" ? '26px' : '',
                  }}
                />
              ) : (
                <item.icon
                  className="self-center"
                  style={{
                    fontSize: '18px',
                    color: item.label === activeTab
                      ? 'var(--border-color)'
                      : 'var(--text-color)',
                  }}
                />
              )}
              <div
                className={`${item.path === "fantasy" ? "mt-0" : "mt-2"} text-xs truncate w-full px-0.5`}
                title={item.label}
              >
                {item.label}
              </div>
            </div>
          ))}
        </nav>
      </footer>
    </>
  );
};

export default Footer;
